import { useCatalogue } from "@/context/CatalogueContext";
import { API } from "@/lib/api";
import { initials } from "@/lib/format";
import { teamColour } from "@/lib/constants";
import { cn } from "@/lib/utils";

const SIZES = { xs: "h-6 w-6 text-[10px]", sm: "h-8 w-8 text-xs", md: "h-11 w-11 text-sm", lg: "h-16 w-16 text-lg" };

export const avatarSrc = (e) => (e?.avatar_file_id ? `${API}/files/${e.avatar_file_id}` : e?.avatar_url || null);

export const EntityAvatar = ({ entity, name, size = "md", className, testid }) => {
  const { teamsById } = useCatalogue();
  const team = teamsById[entity?.team];
  const colour = teamColour(team, team?._index);
  const src = avatarSrc(entity);
  return (
    <span className={cn("relative inline-grid shrink-0 place-items-center overflow-hidden rounded-full font-semibold text-white ring-2 ring-card", SIZES[size], className)}
      style={{ background: `linear-gradient(135deg, ${colour}, color-mix(in srgb, ${colour} 55%, #0B1220))` }} data-testid={testid}>
      {src ? <img src={src} alt={`${name} avatar`} className="h-full w-full object-cover" /> : <span aria-hidden="true">{initials(name)}</span>}
    </span>
  );
};
